import React from 'react';
import { useNavigate } from 'react-router-dom';
import RegisterModal from './RegisterModal';
import PublicHome from '../public/PublicHome';

const RegisterPage: React.FC = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/');
  };

  const handleSwitchToLogin = () => {
    navigate('/login');
  };

  return (
    <>
      <PublicHome />
      <RegisterModal
        open={true}
        onClose={handleClose}
        onSwitchToLogin={handleSwitchToLogin}
      />
    </>
  );
};

export default RegisterPage;
